export const examAdminDashboard = {
  pageTitle: "平台总览",
  pageSubtitle: "围绕题库、试卷、考试三条主链路快速推进的管理后台。",
  superAdminSubtitle: "面向超级管理员的系统运营驾驶舱，聚焦全局进展、风险和待办事项。",
  stats: {
    questionsTotal: "题目总数",
    papersTotal: "试卷总数",
    examsTotal: "考试总数",
    runningExams: "进行中考试",
    upcomingExams: "24 小时内将开始",
    endedPendingArchive: "待归档考试",
    questionsHelper: "草稿题目 {count} 条",
    papersHelper: "草稿试卷 {count} 份",
    examsHelper: "草稿考试 {count} 场",
    runningHelper: "当前正在进行中的考试场次",
    upcomingHelper: "距离开始时间不足 24 小时的考试",
    endedHelper: "已结束但仍可继续收口的考试",
  },
  focusTitle: "核心关注点",
  focusTag: "核心能力",
  focusItems: {
    roleAware: "1. 当前登录角色：{role}，管理后台页面和接口已按角色范围控制。",
    rbac: "2. 题库、试卷、考试、阅卷、夺旗环境管理已按职责角色拆分，按钮级权限按业务需要细化。",
    priority: "3. 聚焦创建、查看与验证主链路，审批流与细粒度权限按业务策略治理。",
  },
  recentExamsTitle: "最近考试",
  recentExamsItem: "试卷版本编号 {paperVersionLabel} · {createdAt}",
  recentExamsEmpty: {
    noExams: "还没有创建考试",
    noPermission: "当前角色不展示考试列表",
  },
  heroTag: "Super Admin",
  heroTitle: "系统运营驾驶舱",
  heroDescription:
    "把题库、试卷、考试三条主链路统一放到一个工作台里，优先暴露风险、堆积和需要立即处理的事项。",
  heroSideTitle: "优先提醒",
  headerActions: {
    createQuestion: "新建题目",
    createExam: "新建考试",
  },
  tasksTitle: "待处理事项",
  tasksTag: "Action Queue",
  tasks: {
    draftQuestions: "草稿题目",
    draftQuestionsHelper: "优先补齐草稿题目的内容和发布状态",
    draftPapers: "草稿试卷",
    draftPapersHelper: "检查组卷进度，避免试卷长期停留在草稿",
    draftExams: "待发布考试",
    draftExamsHelper: "确认考试配置后尽快发布，避免排期延误",
    runningExams: "进行中考试",
    runningExamsHelper: "关注进行中的考试状态、监考和异常反馈",
    endedExams: "已结束待归档",
    endedExamsHelper: "结束后及时归档，保持考试中心状态收敛",
    upcomingExams: "即将开始考试",
    upcomingExamsHelper: "建议提前检查时间窗、试卷和监考配置",
  },
  activityTitle: "最近动态",
  activityTag: "Timeline",
  activityActor: "操作人：{name}",
  activityKinds: {
    question: "题目",
    paper: "试卷",
    exam: "考试",
  },
  risksTitle: "风险与提醒",
  risksTag: "Attention",
  risks: {
    examStartingSoonTitle: "有考试将在 1 小时内开始",
    examStartingSoonDescription: "《{name}》计划于 {time} 开始，建议尽快完成最后检查。",
    examEndingSoonTitle: "有进行中考试将在 2 小时内结束",
    examEndingSoonDescription: "《{name}》预计于 {time} 结束，请关注交卷和阅卷收口。",
    oldDraftQuestionTitle: "存在停留较久的草稿题目",
    oldDraftQuestionDescription: "《{name}》创建于 {time}，建议评估是否继续推进或清理。",
    oldDraftPaperTitle: "存在停留较久的草稿试卷",
    oldDraftPaperDescription: "《{name}》创建于 {time}，建议尽快补齐组卷或整理归档。",
    stableTitle: "当前未发现高优先级风险",
    stableDescription: "题库、试卷、考试的主链路状态整体稳定，可以继续按计划推进。",
  },
  quickActionsTitle: "快捷入口",
  quickActionsTag: "Quick Access",
  quickActions: {
    createQuestionTitle: "新建题目",
    createQuestionDescription: "直接进入题目创建抽屉，补充题库内容。",
    createPaperTitle: "新建试卷",
    createPaperDescription: "从试卷中心开始组卷，完善试卷结构。",
    createExamTitle: "新建考试",
    createExamDescription: "配置考试时间、试卷版本和规则，快速发起考试。",
    goQuestionsTitle: "进入题库中心",
    goQuestionsDescription: "查看题目列表、草稿和归档状态。",
    goPapersTitle: "进入试卷中心",
    goPapersDescription: "统一处理试卷版本、归档和组卷进度。",
    goExamsTitle: "进入考试中心",
    goExamsDescription: "集中查看考试状态、归档和运营数据。",
    goSystemSettingsTitle: "进入系统管理",
    goSystemSettingsDescription: "查看站点配置、安全策略和 AI 接入参数。",
    goAuditLogsTitle: "进入审计日志",
    goAuditLogsDescription: "追踪关键操作记录和登录行为。",
  },
  viewNow: "立即查看",
};
